import { useNavigate, useParams } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { useState ,useEffect} from "react";
import { FaChevronDown, FaChevronUp, FaRegKeyboard, FaShieldVirus } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { GiGraduateCap } from "react-icons/gi";
import { LuDroplet, LuSearchCode } from "react-icons/lu";
const Base_Url = process.env.REACT_APP_BASE_URL;
function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
}
export default function SectionOne()
{
  const navigate=useNavigate();
  const storedUser = localStorage.getItem("customeruser");
  const { id } = useParams();
  const [currentService, setCurrentService] = useState(null);
  const offered=[
      {
        name:"Warranty Coverage ",
        icon:FaShieldVirus,
      },
      {
        name:"Expert technician",
        icon:GiGraduateCap ,
      },
      {
        name:"High Quality Parts",
        icon:FaRegKeyboard,
      },
      {
        name:"Multi-brand Support",
        icon:LuSearchCode,
      },
      {
        name:"Water Damage",
        icon:LuDroplet,
      },
    ];
  const [showMoreInfo, setShowMoreInfo] = useState(true);
  const [selectedImage, setSelectedImage] = useState("");
 
  useEffect(() => {
  const fetchServiceDetails = async () => {
    if (!id) return;

    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${Base_Url}/api/service/getServiceDetails/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setCurrentService(res.data.data);
        setSelectedImage(res.data.data.images?.[0]?.image || "");
  
      } else {
        toast.error(res.data.message || "Failed to fetch service details");
      }
    } catch (err) {
      console.error("❌ Fetch service error:", err);
      toast.error(err.response?.data?.message || "Failed to load servie details");
    }
  };

  fetchServiceDetails();
  }, [id]);

   if (!currentService) {
    return <div className="text-center text-red-500 mt-10">Serivce not found</div>;
  }

  const handleBookService = (id,title) => {
    if (storedUser) {
      navigate("/bookservice", { state: { id: id, title: title } });
    } else {
      toast.warning("Please login to continue");
      setTimeout(() => navigate("/login"), 1000);
      return;
    }
  };
  
    return(
<section className="px-5 py-5 md:px-6 lg:px-20 bg-gray-100">
    <div className="flex flex-row space-x-2 items-center mb-5" onClick={()=>navigate(-1)}>
        <MdKeyboardBackspace className="text-base md:text-lg xl:text-xl" />
        <h2 className="text-base md:text-lg xl:text-xl font-bold">Service detail</h2>
    </div>
    
    <div className="flex flex-col bg-white py-6 px-2 rounded shadow-lg">
    <div className="flex flex-col md:flex-row">
       
       <div className="w-full lg:w-1/2 flex flex-col space-y-5 items-center md:pl-9">
            <img
                src={selectedImage}
                alt={currentService.serviceName}
                className="h-56 md:h-64 xl:h-72 w-72 md:w-72 xl:w-96 object-contain border border-gray-500 rounded"
            />

            <div className="flex gap-2 mt-4">
            {(currentService.images||[]).map((img, i) => (
                <img
                    key={i}
                    src={img.image}
                    onClick={() => setSelectedImage(img.image)}
                    className={`w-14 h-14 md:h-16 md:w-16 xl:h-20 xl:w-20 object-contain border border-gray-500 rounded cursor-pointer ${
                    selectedImage === img.image ? "ring-2 ring-pink-600" : ""
                    }`}
                    alt={`thumb-${i}`}
                />
            ))}
            </div>
            <div className="">
              <button 
                className="border border-red-900 bg-red-100 text-red-700 px-6 mt-10 py-2 rounded-lg font-medium hover:bg-gray-50 hover:scale-105 text-xs md:text-sm xl:text-base"
                onClick={() => handleBookService(currentService.id, currentService.serviceName)}
              >
                  Book Service
              </button>
            </div>
       </div>

        <div className="w-full lg:w-1/2 mt-6 md:mt-0 md:pl-9 pr-5 space-y-5">
        <div className="flex flex-col space-y-2">
          <h1 className="text-base md:text-xl xl:text-2xl font-semibold text-center">{currentService.serviceName}</h1>

          <p className="text-xs md:text-sm xl:text-base">{currentService.description}</p>
          

          <div className="flex flex-row items-center space-x-3 text-xs md:text-sm xl:text-base font-medium border border-gray-500 rounded p-2 xl:p-4">
            <div className="flex flex-col space-y-1 w-2/3">
                <p className=" text-gray-800">₹{formatNumber(currentService.price)}<span> ( Inclusive of all Taxes )</span></p>
                <p className="text-gray-500">Starts from : <span className="line-through text-gray-500">₹{formatNumber(currentService.oldPrice)}</span> </p>
            </div>   
            <div className="w-1/3">
                <p className="text-white bg-[#E96364] px-2 py-1 rounded text-center">Save ₹{currentService.oldPrice - currentService.price}</p>
            </div>                          
          </div>

          <div className="">
            <p className="text-sm md:text-base xl:text-lg font-medium mb-2">Services we offeres</p>
            <div className="grid gap-y-2 p-2">
                {(currentService.serviceType||[]).map((item, i) => (
                    <div key={i} className="flex items-center gap-2 text-gray-800 text-xs md:text-sm xl:text-base">
                        <FaCheckCircle className="text-green-600" />
                        <span>{item}</span>
                    </div>
                ))}
            </div>
          </div>

          <div className="">
              <div className="flex items-center space-x-2 mb-2">
                <p className="text-sm md:text-base xl:text-lg font-medium">More Info</p>
                <button
                  onClick={() => setShowMoreInfo(!showMoreInfo)}
                  className="text-pink-700 text-xs md:text-sm xl:text-base flex items-center gap-1"
                >
                  {showMoreInfo ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>

              {showMoreInfo && currentService?.moreInfo?.length > 0 && (
              <div className="space-y-4 bg-gray-50 p-4 rounded shadow-inner">
                {(currentService.moreInfo||[]).map((section, i) => (
                <div key={i}>
                  <p className="text-xs md:text-sm xl:text-base font-semibold mb-1 text-gray-800">{section.name}</p>
                  {section.values?.length > 0 && (
                  <ul className="list-disc list-inside space-y-1 text-xs md:text-sm xl:text-base text-gray-700">
                  {section.values.map((val, j) => (
                    <li key={j}>{val}</li>
                  ))}
                  </ul>
                  )}
                </div>
                ))}
              </div>
              )}
          </div>
        </div>
       </div>
    </div>

    <div className="mt-5 border-t border-[#A63F40] pt-5">
       <p className="text-lg md:text-xl xl:text-2xl font-medium mb-2 text-center">Services we offeres</p>
        <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 justify-between py-2 px-2 md:px-8">
            {(offered||[]).map((item, i) => (
            <div key={i} className="flex flex-col items-center gap-1 md:gap-2 text-gray-800 text-xs md:text-sm xl:text-base">
                <item.icon className="text-[#A63F40] text-3xl md:text-4xl xl:text-5xl" />
                <span>{item.name}</span>
            </div>
            ))}
        </div>
    </div>
    </div>

    
    </section>
    );
}